import React from "react";
import PropTypes from "prop-types";
import { Field, propTypes, reduxForm } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { withHandlers, withState } from "recompose";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import { translate, userLogin } from "ra-core";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../config";
import { isStaging } from "../common/utilities";
import Cookies from "js-cookie";

const RECAPTCHA_VALUE = "recaptchaValue";

const styles = () => ({
    form: {
        padding: "0 1em 1em 1em"
    },
    input: {
        marginTop: "1em"
    },
    button: {
        width: "100%"
    }
});

const recaptchaRef = React.createRef();

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
    meta: { touched, error } = {}, // eslint-disable-line react/prop-types
    input: { ...inputProps }, // eslint-disable-line react/prop-types
    ...props
}) => (
    <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />
);
const login = (auth, dispatch, { redirectTo }) => {
    // send saved captcha to auth
    auth.recaptcha = Cookies.get(RECAPTCHA_VALUE)
        ? Cookies.get(RECAPTCHA_VALUE)
        : null;

    // remove captcha cookie
    Cookies.remove(RECAPTCHA_VALUE);

    dispatch(userLogin(auth, redirectTo));
};

const LoginForm = ({
    classes,
    isLoading,
    solvedCaptcha,
    onSolvedCaptcha,
    onExpiredCaptcha,
    handleSubmit,
    translate
}) => (
    <form onSubmit={handleSubmit(login)}>
        <div className={classes.form}>
            <div className={classes.input}>
                <Field
                    autoFocus
                    id="username"
                    name="username"
                    component={renderInput}
                    label={translate("ra.auth.username")}
                    disabled={isLoading}
                />
            </div>
            <div className={classes.input}>
                <Field
                    id="password"
                    name="password"
                    component={renderInput}
                    label={translate("ra.auth.password")}
                    type="password"
                    disabled={isLoading}
                />
            </div>
        </div>
        {
            /* isStaging() && */ <ReCAPTCHA
                className="recaptcha"
                ref={recaptchaRef}
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={onSolvedCaptcha}
                onExpired={onExpiredCaptcha}
            />
        }
        <CardActions>
            <Button
                variant="raised"
                type="submit"
                color="primary"
                onClick={() => {
                    recaptchaRef.current.reset();
                }}
                disabled={false}
                className={classes.button}
            >
                {isLoading && <CircularProgress size={25} thickness={2} />}
                {translate("ra.auth.sign_in")}
            </Button>
        </CardActions>
    </form>
);
LoginForm.propTypes = {
    ...propTypes,
    classes: PropTypes.object,
    redirectTo: PropTypes.string
};

const mapStateToProps = state => ({
    isLoading: state.admin.loading > 0
});

const enhance = compose(
    // we use withState and withHandlers helpers from recompose,
    // see here: https://github.com/acdlite/recompose/blob/master/docs/API.md#withstate
    withState("solvedCaptcha", "setSolvedCaptcha", () => {
        return isStaging() ? true : true;
    }),
    withHandlers({
        onSolvedCaptcha: props => value => {
            props.setSolvedCaptcha(() => true);

            //save captcha value returned from Google
            Cookies.set(RECAPTCHA_VALUE, value);
        },
        onExpiredCaptcha: props => {
            props.setSolvedCaptcha(() => false);
        }
    }),
    withStyles(styles),
    translate,
    connect(mapStateToProps),
    reduxForm({
        form: "signIn",
        validate: (values, props) => {
            const errors = {};
            const { translate, anyTouched } = props;
            if (anyTouched) {
                if (!values.username)
                    errors.username = translate("ra.validation.required");
                if (!values.password)
                    errors.password = translate("ra.validation.required");
            }
            return errors;
        }
    })
);

export default enhance(LoginForm);



// WEBPACK FOOTER //
// ./src/components/MyLoginForm.js